import { useState, useEffect } from 'react';
import { companyBrandingService, CompanyBranding } from '@/services/company-branding-service';
import { useAuth } from './useAuth';

interface UseCompanyBrandingReturn extends CompanyBranding {
  canCustomizePDF: boolean;
  loading: boolean;
  refresh: () => Promise<void>;
}

export const useCompanyBranding = (): UseCompanyBrandingReturn => {
  const { user } = useAuth();
  const [branding, setBranding] = useState<CompanyBranding>({
    companyName: 'dpewizard',
    companyLogoUrl: null,
    isProUser: false,
    primaryColor: undefined
  });
  const [loading, setLoading] = useState(true);

  const loadBranding = async () => {
    if (!user?.id) {
      setBranding({
        companyName: 'dpewizard',
        companyLogoUrl: null,
        isProUser: false
      });
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const brandingData = await companyBrandingService.getCompanyBranding(user.id);
      setBranding(brandingData);
    } catch (error) {
      console.error('Error loading company branding:', error);
      setBranding({
        companyName: 'dpewizard',
        companyLogoUrl: null,
        isProUser: false,
        primaryColor: undefined
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBranding();
  }, [user?.id]);

  return {
    ...branding,
    canCustomizePDF: branding.isProUser,
    loading,
    refresh: loadBranding
  };
};
